export const loading = "materials/loading";
export const err = "materials/err";
export const req = "materials/req";
export const res = "materials/res";
export const update = "materials/update";
